import {
    ERROR_MESSAGES,
} from 'constants/validation-error-messages';
import * as yup from 'yup';

export const schema = yup.object({
    first_name: yup.string().required(ERROR_MESSAGES.REQUIRED),
    last_name: yup.string().required(ERROR_MESSAGES.REQUIRED),
});
